import React, { Component } from 'react';
import moment from 'moment';
import Collapsible from 'react-collapsible';
import Countdown, { zeroPad } from 'react-countdown-now';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import packageJson from '../../../package.json';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import Counter from '../../components/Counter';
import classes from './RouterTroubleshooting.css';

export class RouterTroubleshooting extends Component {
  constructor(props) {
    super(props);
    this.rebootHandler = this.rebootHandler.bind(this);
    this.resetHandler = this.resetHandler.bind(this);
    this.state = {
      success: false,
      error: false,
      action: null,
      result: null,
      confirmModal: false,
      upArrowsM: false,
    };
    // console.log("RouterTroubleshooting props:", props);
  }

  componentDidMount() {}
  componentWillUpdate() {}
  componentDidUpdate() {}
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetSettingsErrorSuccess();
  };
  confirmModalConfirmHandler = () => {
    if (this.state.action === 'Reboot the router?') {
      this.props.onRebootRouter();
    } else if (this.state.action === 'Proceed with factory reset?') {
      this.props.onResetRouter();
    }
    this.closeModal();
  };
  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
  };
  closeModal = () => {
    this.setState({ confirmModal: false });
  };
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  rebootHandler() {
    this.onOpenModal(
      'This will interrupt connectivity for a few minutes.',
      'Reboot the router?'
    );
  }
  resetHandler() {
    this.onOpenModal(
      'Factory reset restores the device to the original factory settings. This may require you to reconnect all devices.',
      'Proceed with factory reset?'
    );
  }
  closeHandlerM = () => {
    this.setState({
      upArrowsM: false,
    });
  };

  openHandlerM = () => {
    this.setState({
      upArrowsM: true,
    });
  };

  render() {
    if (this.props.error && !this.state.error) {
      this.setState({ error: true });
      this.props.onResetSettingsErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true });
      this.props.onResetSettingsErrorSuccess();
    }

    let routerTroubleshootingContent;

    if (this.props.settingsLoading) {
      routerTroubleshootingContent = <Spinner />;
    } else if (
      this.props.realWan &&
      (!this.props.realWan.connectionState ||
        this.props.realWan.connectionState !== 'connected')
    ) {
      routerTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          This Router is disconnected. Please ask the customer to reconnect
          inorder to perform router troubleshooting tasks.
        </div>
      );
    } 
     else if (this.props.checkingWan && this.props.timerStart) 
    {
      routerTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          The router is restarting... estimated wait time is 2-10 minutes,
          elapsed time{' '}
          <Counter startDate={this.props.timerStart} />
        </div>
      );
    } else if (!this.props.realSettings && !this.props.realWan) {
      routerTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          Router Troubleshooting not available. Try to log in again form
          Gateway.
        </div>
      );
    } else {
      routerTroubleshootingContent = (
        <Box>
          <div className={classes.TitleArea}>
            <div>Router Reboot</div>
            <button
              className={classes.ActionButton}
              id="RebootButton"
              title={
                this.props.firmwareDisplayUpdateSpinner 
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
               }
              onClick={this.rebootHandler}
              disabled={
                (this.props.checkingWan && this.props.timerStart) ||
                (this.props.wan?.loaded && this.props.wan?.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner ||
                this.props.isSteering || 
                this.props.optimizeRouterDisplayUpdateSpinner
              }
            >
              Reboot
            </button>
          </div>
      <div className={classes.showDesktop}>
        <div className={classes.Separator} />
          <div className={classes.TitleArea}>
            <div>Factory Reset</div>
            <button
              className={classes.ActionButton}
              id="ResetButton"
              title={
                this.props.firmwareDisplayUpdateSpinner 
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
               }
              onClick={this.resetHandler}
              disabled={
                (this.props.checkingWan && this.props.timerStart) ||
                (this.props.wan?.loaded && this.props.wan?.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner || 
                this.props.optimizeRouterDisplayUpdateSpinner
              }
            >
              Reset
            </button>
          </div>
        </div>
          
        </Box>
      );
    }

    let arrowM = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrowsM) {
      arrowM = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    }

    return (
      <Box>
        <div className={classes.RouterTroubleshooting}>
          <div className={classes.showDesktop}>
            <div className={classes.TitleArea}>
              <h3 id = 'routerTroubleshootingTxt' style={{ paddingRight: 20 }}>Router Troubleshooting</h3>
            </div>
            <div className={classes.Separator} />
            {routerTroubleshootingContent}
          </div>
          <div
            className={[classes.showMobile].join(' ')}
            style={{ borderRadius: '5px 5px 0px 0px' }}
          >
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandlerM();
              }}
              onClosing={() => {
                this.closeHandlerM();
              }}
              trigger={
                <Box>
                  <div>
                    <div className={classes.MobileTitleArea}>
                      <div className={classes.Header}>
                        <h3>Router Troubleshooting</h3>
                      </div>
                      <button className={classes.OpenCloseButton}>
                        {arrowM}
                      </button>
                    </div>
                  </div>
                </Box>
              }
            >
              <div>
                {' '}
                <div className={classes.Separator} />
                {routerTroubleshootingContent}
              </div>
            </Collapsible>
          </div>
        </div>
        <Modal show={this.state.confirmModal} modalClosed={this.closeModal}>
          <Confirm
            id={'RouterTroubleshootingConfirm'}
            action={this.state.action}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            deviceGroupConfirmation
          />
        </Modal>
        <Modal
          show={this.state.error}
          modalClosed={this.successErrorResetHandler}
        >
          <Error id={'RouterTroubleshootingError'} />
        </Modal>
        <Modal
          show={this.state.success}
          modalClosed={this.successErrorResetHandler}
        >
          <Success id={'RouterTroubleshootingSuccess'} />
        </Modal>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settingsLoading: state.settings.loading,
    settingsLoaded: state.settings.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    realWan: state.wan.realWan,
    realDevices: state.devices.realDevices,
    devicesByEquipment: state.devices.devicesByEquipment,
    checkingWan: state.wan.checkingWan,
    timerStart: state.wan.timerStart,
    success: state.settings.success,
    error: state.settings.error,
    isSteering: state.devices.realDevices.some(d => d.steering && d.steering.forced
      && d.steering.forced.expiresAt && moment().isBefore(moment(d.steering.forced.expiresAt))),
    firmwareDisplayUpdateSpinner: state.settings.firmwareDisplayUpdateSpinner,
    wan: state.wan,
    optimizeRouterDisplayUpdateSpinner: state.settings.optimizeRouterDisplayUpdateSpinner
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRebootRouter: () => dispatch(actions.rebootRouter(false, false)),
    onResetRouter: () => dispatch(actions.resetRouter()),
    onResetSettingsErrorSuccess: () =>
      dispatch(actions.resetSettingsErrorSuccess()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(RouterTroubleshooting, api));
